import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Container } from 'reactstrap';
import * as elements from '../data/Elements';
import * as Records from '../store/Records';
import * as utility from '../data/Utility';

const createRecord12LeadType = {
    hr: "hr",
    pAxis: "pAxis",
    pr: "pr",
    qrs: "qrs",
    qt: "qt",
    qtc: "qtc",
    qtcB: "qtcB",
    qtcF: "qtcF",
    rAxis: "rAxis",
    rr: "rr",
    tAxis: "tAxis"
}

class CreateRecord12Lead extends React.Component {
    constructor(props) {
        super(props);

        const disabled = utility.propCheck(props.disabled, false);
        const handleKeyDown = utility.propCheck(props.handleKeyDown, null);
        const saveButton = utility.propCheck(props.saveButton, false);
        this.state = {
            disabled: disabled,
            edited: false,
            handleKeyDown: handleKeyDown,
            saveButton: saveButton
        };

        this.handleSave = this.handleSave.bind(this);
        this.handleValue = this.handleValue.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps != null &&
            prevProps.disabled !== this.props.disabled &&
            this.props.disabled !== this.state.disabled) {
            this.setState({
                disabled: this.props.disabled
            });
        }
    }

    handleSave() {
        this.props.recordsDispatch.update12Lead();
        this.props.recordsDispatch.setRefresh( true );
        this.setState({
            edited: false
        });
    }

    handleValue(type, value) {
        const record = this.props.recordsState.record;

		if ( /^-{0,1}\d*$/.test(value) ) {
			record[type] = value;
		}

        this.props.recordsDispatch.set(record);
        if (!this.state.edited) {
            this.setState({
                edited: true
            });
        }
    }

    render() {
        const disabled = this.state.disabled;
        const handleKeyDown = this.state.handleKeyDown;
        var hr = null;
        var pAxis = null;
        var pr = null;
        var qrs = null;
        var qt = null;
        var qtc = null;
        var qtcB = null;
        var qtcF = null;
        var rAxis = null;
        var record = this.props.recordsState.record;
        var rr = null;
        const save = "Save";
        const showSaveButton = (
            this.state.edited &&
            this.state.saveButton
        );
        var tAxis = null;

        if (record != null) {
            hr = elements.getFormGroup("Average HR", true, elements.getInputGroup(elements.getInput("hrInput", disabled, (e) => this.handleValue(createRecord12LeadType.hr, e.target.value), handleKeyDown, elements.inputTypes.text, record.hr), "BPM"));
            pAxis = elements.getFormGroup("P Axis", true, elements.getInputGroup(elements.getInput("pAxisInput", disabled, (e) => this.handleValue(createRecord12LeadType.pAxis, e.target.value), handleKeyDown, elements.inputTypes.text, record.pAxis), "degrees"));
            pr = elements.getFormGroup("PR Interval", true, elements.getInputGroup(elements.getInput("prInput", disabled, (e) => this.handleValue(createRecord12LeadType.pr, e.target.value), handleKeyDown, elements.inputTypes.text, record.pr), "ms"));
            qrs = elements.getFormGroup("QRS Duration", true, elements.getInputGroup(elements.getInput("qrsInput", disabled, (e) => this.handleValue(createRecord12LeadType.qrs, e.target.value), handleKeyDown, elements.inputTypes.text, record.qrs), "ms"));
            qt = elements.getFormGroup("QT", true, elements.getInputGroup(elements.getInput("qtInput", disabled, (e) => this.handleValue(createRecord12LeadType.qt, e.target.value), handleKeyDown, elements.inputTypes.text, record.qt), "ms"));
            qtc = elements.getFormGroup("QTc", true, elements.getInputGroup(elements.getInput("qtcInput", disabled, (e) => this.handleValue(createRecord12LeadType.qtc, e.target.value), handleKeyDown, elements.inputTypes.text, record.qtc), "ms"));
            qtcB = elements.getFormGroup("QTcB", true, elements.getInputGroup(elements.getInput("qtcBInput", disabled, (e) => this.handleValue(createRecord12LeadType.qtcB, e.target.value), handleKeyDown, elements.inputTypes.text, record.qtcB), "ms"));
            qtcF = elements.getFormGroup("QTcF", true, elements.getInputGroup(elements.getInput("qtcFInput", disabled, (e) => this.handleValue(createRecord12LeadType.qtcF, e.target.value), handleKeyDown, elements.inputTypes.text, record.qtcF), "ms"));
            rAxis = elements.getFormGroup("R Axis", true, elements.getInputGroup(elements.getInput("rAxisInput", disabled, (e) => this.handleValue(createRecord12LeadType.rAxis, e.target.value), handleKeyDown, elements.inputTypes.text, record.rAxis), "degrees"));
            rr = elements.getFormGroup("Average RR", true, elements.getInputGroup(elements.getInput("rrInput", disabled, (e) => this.handleValue(createRecord12LeadType.rr, e.target.value), handleKeyDown, elements.inputTypes.text, record.rr), "ms"));
            tAxis = elements.getFormGroup("T Axis", true, elements.getInputGroup(elements.getInput("tAxisInput", disabled, (e) => this.handleValue(createRecord12LeadType.tAxis, e.target.value), handleKeyDown, elements.inputTypes.text, record.tAxis), "degrees"));
        }

        return (
            <Container className="gap group-border" fluid>
                <h4 className="center">12-Lead Data</h4>
				<div className="input-shortened">
					{hr}
					{pr}
					{qrs}
					{qt}
					{qtc}
					{pAxis}
					{rAxis}
					{tAxis}
					{rr}
					{qtcB}
					{qtcF}
					{showSaveButton && (
						<div className="button-gap">
							<Button className="button" onClick={this.handleSave} title={save}>{save}</Button>{' '}
							<div className="gap" />
						</div>
					)}
				</div>
            </Container>
        );
    }
}

export default connect(
    state => ({
        recordsState: state.records
    }),
    dispatch => ({
        recordsDispatch: bindActionCreators(Records.actionCreators, dispatch)
    })
)(CreateRecord12Lead);



// WEBPACK FOOTER //
// ./src/components/CreateRecord12Lead.js